import {
    Button,
    Dialog,
    DialogContent,
    Grid,
    Paper,
    TextField,
    Typography,
    Divider,
    IconButton,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import { deleteTipoTarea, editTipoTarea } from '../../../services/apis';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';


export const FormEditarTipoTarea = ({ open, setOpen, tiposDeTarea, cargarEstados }) => {
    const [tiposEditables, setTiposEditables] = useState([]);
    const [errorAlert, setErrorAlert] = useState(false);
    const [erroRespues, setErroRespues] = useState(false);

    useEffect(() => {
        setTiposEditables(tiposDeTarea.map((tipo) => ({ ...tipo })));
    }, [tiposDeTarea, open]);

    const handleChange = (event, index) => {
        const { name, value } = event.target;
        const nuevosTipos = [...tiposEditables];
        nuevosTipos[index][name] = value;
        setTiposEditables(nuevosTipos);
        setErrorAlert(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const guardarCambios = async (index) => {
        const tipoEditado = tiposEditables[index];
        if (!tipoEditado.nombre || !tipoEditado.color) {
            setErrorAlert(true);
            return;
        }

        try {
            const response = await editTipoTarea(tipoEditado);
            if (response.success === true) {
                cargarEstados();
                handleClose();
            } else {
                setErrorAlert(response.error || 'Error del servidor');
            }
        } catch (error) {
            console.error('Error al enviar el tipo de tarea', error);
            setErrorAlert(true);
        }
    };

    const eliminarTipo = async (index) => {
        const confirmacion = window.confirm('¿Estás seguro de que deseas eliminar este tipo de tarea?');
        if (!confirmacion) return;

        const id = tiposEditables[index].id;
        try {
            const response = await deleteTipoTarea(id);
            if (response.success) {
                cargarEstados();
                handleClose();
            } else {
                setErrorAlert(response.error || 'Error al eliminar');
                console.error('Error al eliminar', response.error);

            }
        } catch (error) {
            console.error('Error al eliminar', error);
            setErrorAlert(error.error || 'Error al eliminar');

        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogContent>


                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                >
                    <Typography variant="h6" gutterBottom>
                        Editar Tipos de Tarea
                    </Typography>
                    <IconButton aria-label="close" onClick={handleClose}>
                        <CancelIcon color='primary' sx={{ fontSize: 30 }} />
                    </IconButton>
                </Grid>

                {tiposEditables.map((tipo, index) => (
                    <Paper
                        key={index}
                        elevation={3}
                        style={{
                            padding: '16px',
                            marginBottom: '16px',
                            borderLeft: `8px solid ${tipo.color}`,
                            backgroundColor: '#f9f9f9',
                        }}
                    >
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Nombre"
                                    name="nombre"
                                    value={tipo.nombre}
                                    onChange={(e) => handleChange(e, index)}
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                <Typography variant="body2" gutterBottom>
                                    Color
                                </Typography>
                                <input
                                    type="color"
                                    name="color"
                                    value={tipo.color}
                                    onChange={(e) => handleChange(e, index)}
                                    style={{
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '40px',
                                        height: '40px',
                                        cursor: 'pointer',
                                        padding: 0,
                                        background: 'none',
                                    }}
                                />
                            </Grid>

                            <Grid container spacing={1} justifyContent="flex-end">
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() => eliminarTipo(index)}
                                        size="small"
                                        title="Eliminar"
                                    >
                                        <DeleteIcon />
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => guardarCambios(index)}
                                        size="small"
                                        title="Guardar"
                                    >
                                        <SaveIcon />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                ))}
            </DialogContent>

            {errorAlert && (
                <AlertError
                    open={errorAlert}
                    setOpen={setErrorAlert}
                    titulo="Error"
                    mensaje={"Error al borrar, revisa que no haya tareas asociadas a este tipo"}
                />
            )}
        </Dialog>
    );
};
